import {Component, EventEmitter, Input, Output} from '@angular/core';
import {NgStyle} from "@angular/common";
import {TranslateModule} from "@ngx-translate/core";

export interface IDonationCustomButtonStyles{
    background: string;
    textColor: string;
    icon: string;
}
export interface IDonationCustomButton {
    title: string;
    amount: number;
    styles: IDonationCustomButtonStyles;
    trigger?: string;
}

@Component({
    selector: 'white-label-donation-widget-button',
    templateUrl: './donation-widget-button.component.html',
    standalone: true,
    imports: [
        NgStyle,
        TranslateModule
    ]
})
export class DonationWidgetButtonComponent{
    @Input() customButtonStyles: IDonationCustomButton = {
        title: 'not implemented',
        amount: 0,
        styles: {
            background: 'transparent',
            textColor: 'white',
            icon: '',
        },
        trigger: 'default'
    };
    @Output() onClick: EventEmitter<any> = new EventEmitter();

    constructor() {
    }

}
